"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Casestudyhero() {
  const paragraphs = ["HotelRevBaBa partnered with a boutique property in Thailand to overhaul their digital presence. By implementing a data-driven OTA strategy and optimizing their tech stack, we transformed their online visibility and captured high-intent travelers.", "Our approach focused on dynamic rate parity and targeted listing optimization. We moved away from generic marketing, instead leveraging real-time market intelligence to adjust pricing and inventory availability across all major booking channels.", "The result was a significant shift in booking volume and revenue. We invite you to explore the specific metrics and strategic pivots that led to this successful turnaround in a competitive market."];
  return <section data-section-id="1987" id="casestudyhero" className="bg-slate-50 text-slate-900 py-28 md:py-36">
      <div className="mx-auto max-w-[1280px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
          {}
          <div className="relative lg:col-span-5">
            {}
            <div aria-hidden="true" className="pointer-events-none absolute -bottom-6 -left-4 select-none font-default text-[10rem] leading-none text-blue-900/10 md:text-[14rem]">
              01
            </div>

            <div className="relative">
              {}
              <span aria-hidden="true" className="absolute -left-2 -top-2 z-10 h-3.5 w-3.5 border-l border-t border-blue-900" />
              <span aria-hidden="true" className="absolute -right-2 -top-2 z-10 h-3.5 w-3.5 border-r border-t border-blue-900" />
              <span aria-hidden="true" className="absolute -bottom-2 -left-2 z-10 h-3.5 w-3.5 border-b border-l border-blue-900" />
              <span aria-hidden="true" className="absolute -bottom-2 -right-2 z-10 h-3.5 w-3.5 border-b border-r border-blue-900" />

              <div className="relative aspect-[4/5] w-full overflow-hidden rounded-lg shadow-lg border border-blue-200">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/thailand_hotel_revenue_growth.png" alt="Boutique hotel in Thailand showing modern revenue management dashboard and booking analytics" loading="lazy" decoding="async" className="h-full w-full object-cover" />
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-7">
            {}
            <p className="font-default text-xs uppercase text-blue-700 tracking-[0.16em]">
              § Case Study — Thailand Boutique Growth
            </p>

            {}
            <h1 className="mt-6 font-default font-bold text-blue-950" style={{
            fontSize: "clamp(2.75rem, 5.4vw, 4.75rem)",
            lineHeight: 1.02,
            letterSpacing: "-0.022em"
          }}>
              Driving <em className="italic font-default">Revenue</em> through precision.
            </h1>

            {}
            <div className="mt-8 flex items-center" aria-hidden="true">
              <span className="h-px w-[200px] bg-blue-200" />
              <span className="ml-1 h-1.5 w-1.5 rounded-lg bg-blue-600" />
            </div>

            {}
            <div className="mt-10 space-y-6">
              {paragraphs.map((text, i) => <p key={i} data-index={i} className="font-default text-slate-700" style={{
              fontSize: "clamp(1.0625rem, 1.25vw, 1.1875rem)",
              lineHeight: 1.6
            }}>
                  {text}
                </p>)}
            </div>

            {}
            <p className="mt-8 font-default text-[13px] italic text-slate-500">
              — Data-driven strategies for sustainable growth.
            </p>

            {}
            <div className="mt-12 flex flex-col items-start gap-6 sm:flex-row sm:items-center">
              <Button asChild className="h-auto rounded-lg bg-blue-600 px-7 py-3.5 font-default text-xs font-medium uppercase text-white hover:bg-blue-700 shadow-md" style={{
              letterSpacing: "0.12em"
            }}>
                <Link to="#">View Our Services</Link>
              </Button>

              <Link to="/ContactPage" className="group inline-flex items-center gap-2 font-default text-blue-900" style={{
              fontSize: "1.0625rem"
            }}>
                <span className="border-b border-blue-900 pb-0.5 transition-[border-width] group-hover:border-b-2">
                  Book a Consultation
                </span>
                <ArrowRight className="h-4 w-4" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}